var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuDotsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_358_6857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 10.0001C3.33333 9.07966 2.58714 8.33347 1.66667 8.33347C0.746192 8.33347 0 9.07966 0 10.0001C0 10.9206 0.746192 11.6668 1.66667 11.6668C2.58714 11.6668 3.33333 10.9206 3.33333 10.0001Z",
    fill: "#374957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6673 10.0001C11.6673 9.07966 10.9211 8.33347 10.0006 8.33347C9.08017 8.33347 8.33398 9.07966 8.33398 10.0001C8.33398 10.9206 9.08017 11.6668 10.0006 11.6668C10.9211 11.6668 11.6673 10.9206 11.6673 10.0001Z",
    fill: "#374957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9994 10.0001C19.9994 9.07966 19.2532 8.33347 18.3327 8.33347C17.4122 8.33347 16.666 9.07966 16.666 10.0001C16.666 10.9206 17.4122 11.6668 18.3327 11.6668C19.2532 11.6668 19.9994 10.9206 19.9994 10.0001Z",
    fill: "#374957"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_358_6857"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "matrix(0 -1 1 0 0 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDotsIcon);
export default __webpack_public_path__ + "static/media/menu-dots-icon.296f985421ede17320feca037f49dab0.svg";
export { ForwardRef as ReactComponent };